import { render, staticRenderFns } from "./TemplateApprovalForm.vue?vue&type=template&id=77c471f2&scoped=true"
import script from "./TemplateApprovalForm.vue?vue&type=script&lang=js"
export * from "./TemplateApprovalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c471f2",
  null
  
)

export default component.exports